import englishMessages from 'ra-language-english';
export default {
    ...englishMessages,
    type:{
        playfile:'Play File',
        menu_star:'Asterisk Menu',
        menu: 'Menu',
        EXT: 'Extension',
        DIR: 'Folder',
        BIN: 'File',
        AUDIO: 'Audio',
        INI: 'INI File',
        YMGR: 'Log File',
        CSV: 'CSV File',
        HTML: 'HTML File',
        undefined: '',
        admin_login: 'Admin Login',
        confbridge: 'Confrence/Broadcast'


    },

    trans: {
        oldSite: 'Go to old version',
        units_left: 'Units left',
        currentUser: 'Current user:',
        transfer_units:'Transfer units another system',
        destination: 'Destination',
        destinationHT: 'Phone number of ',
        ok: 'OK',
        cancel: 'Cancel',
        alert: 'Admin',
        approveDelete: 'Delete file/s?',
        uploadDone: 'Upload completed',
        noname: 'File name is required',
        convertToWAV: 'Convert file to WAV format',
        messages: 'Messages',
        extensions: 'Extensions',
        search: 'Search',
        load_log: 'Load Statistics',
        download_log: 'Download as XLS',
        from: 'from -',
        to: 'to -',
        get_Statistics: 'Load Statistics for following dates:',
        TEXT: 'Create Text File',
        UPLOAD:'Upload Locale File',
        RECORDING: 'Create New Recording',
        uploadfile: 'Upload File',
        newfolder: 'New Folder/Extension',
        file_format: 'Upload option:',
        write_text: 'Replace with content...',
        file_name: 'File Name',
        new_file_name: 'New Name',
        new_file_ext: 'File Type (extension)',
        folder_name: 'Folder/Extension Name',
        copy: 'Copy',
        cut:'Cut',
        paste: 'Paste',
        delete: 'Delete',
        extDesign: 'Extesion Wizard',
        iniEditor: 'Text File Editor',
        fileHandler: 'File Handler',
        SMS: 'SMS',
        Campaign: 'Campaign',
        Transfer: 'Transfer Units',
        Expired: 'Expired',
        name: 'Name',
        path: 'Path',
        size: 'File Size',
        updateTime: 'Modification Date',
        transactionTime: 'Transaction Time',
        amount: 'Total Amount of Units',
        description: 'Description',
        who: 'Who?',
        newBalance: 'New Balance',
        expireDate: 'New Expiration Date',
        campaignId: 'Campaign ID:',
        useUnits: 'Units Usage',
        useUnitsStat: 'Units Destribution',
        callStats: 'Calls Statistics',
        choose_exts: 'Show relevent extentions',
        chart_settings: 'Chart Settings',
        now_listening: 'Currently Listening:',
        current_balance: 'Units Balance:',
        Others: 'Others',
        units_purchased: 'Units Purchased this Month',
        units_used: 'Units Used this Month',
        units_expired_date: 'Units Expiration Date',
        units_last_transaction: 'Last Action Charged',
        DurationInSeconds: 'Time in extension in seconds',
        NumberOfCalls: 'Entries to extenstion',
        Entries: 'Total entries to extension',
        UniqueEntries: 'Unique Incoming Numbers',
        TotalTime: 'Total Time',
        AvrageTime: 'Avrage Time per Dialer',
        CallsPerX: 'Calls per Extension',
        CallsPerMonth: 'Total Time per Extension per Month',
        UserID: 'System Number -',
        betaVersion: 'You are currently running a beta-version!',
        runCampaign:'Run Campaign',
        scheduleCampaign:'Schedule Campaign',
        chooseAction: 'Select Action',
        campaignTemplate: 'Template',
        userDID: 'System Number -',
        EXT: 'Extension',
        DIR: 'Folder',
        BIN: 'File',
        AUDIO: 'Audion',
        INI: 'Ini File',
        YMGR: 'Log File',
        CSV: 'CSV File',
        HTML: 'HTML File',
        menu: 'Menu',
        undefined: '',
        uploadTitle: 'Drag files into frame or click inside to select files...',
        renamefile: 'Rename',
        newfile: 'NewFile',
        ROOT: 'Root Entry',
        forumLink: 'INI editor',
        here: 'for more details and support click here'
        },
        
    pos: {
        menu:{
            Campaigns: "Campaigns"
        },
        accessibility: 'Accessibility Statement',
        search: 'Search',
        configuration: 'Configuration',
        language: 'Language',
        hebrew: 'עברית',
        yiddish: 'יידיש',
        theme: {
            name: 'Theme',
            light: 'Light',
            dark: 'Dark',
        },
        Softphone: {
            name: 'Softphone',
        },
        Statistics: {
            name: 'Statistics'
        },
        UnitsStatistics: {
            name: 'Units'
        },
        dashboard: {
            username: 'System ID: ',
            transaction_list: 'Last Transactions',
            monthly_revenue: 'Monthly Revenue',
            new_orders: 'New Orders',
            pending_reviews: 'Pending Reviews',
            new_customers: 'New Customers',
            pending_orders: 'Pending Orders',
            order: {
                items:
                    'by %{customer_name}, one item |||| by %{customer_name}, %{nb_items} items',
            },
            welcome: {
                title: 'Welcome to react-admin demo',
                subtitle:
                    "This is the admin of an imaginary poster shop. Fell free to explore and modify the data - it's local to your computer, and will reset each time you reload.",
                aor_button: 'react-admin site',
                demo_button: 'Source for this demo',
            },
        },
    },
    resources: {
        Customers:{
            name: 'Customer Details'},
        search: 'Search String',
        filter: 'Filter String',
        Exts: {
            name: 'Extensions'
        },
        IVR: {
            name: 'IVR',
            props: 'Props',
            files: 'Files',
            title: 'Title',
            filename: 'File Name',
            expand: 'Load Extension',
            fileType: 'Type',
            what: 'Path',
            mtime: 'Date',
            size: 'Size',
            extType: 'Extension Type',
            extTitle: 'Extension Title',
            extname: 'Extension Name'
        },
        Exchange: {
            name: 'מרכזיה',
        },
        Statistics: {
            name: 'Statistics'
        },
        Softphone: {
            name: 'Softphone',
            duration: 'Duration',
            callerIdNum: "Callers Number",
            did: "Number Called",
            id: "Call",
            path: 'Path',
            transferFrom: "Transfored From",
            incomingCalls: "Incoming Calls",
            hangup: 'Hangup',
            pickup: 'Answer',
            transfer: 'Transfer Call'
        },
        Profile: {
            name: 'Profile',
        },
        profile: {
            username: 'System ID',
            name: 'User name',
            email: 'Email',
            fax: 'Fax',
            phones: 'Contact phone',
            organization: 'Organization name',
            contactName: 'Personal contact name',
            accessPassword: 'Manager password',
            recordPassword: 'Recording password'
        },
        templates: {
            name: 'Campaign Name',
            new_template: 'New Campaign',
            quick_send: 'Quick Send',
            Username: 'Username',
            props: 'Campaign Props',
            phoneNumbers: 'Phone Numbers',
            templateId: 'Template ID',
            description: 'Template Description',
            entriesCount: 'Total Number of Entries',
            maxActiveChannels: 'Maximum Active Channels',
            maxBridgedChannels: 'Maximum Bridged Channels',
            maxDialAttempts: 'Maximum Dial Attempts',
            redialPolicy: 'Redial Policy',
            redialWait: 'Minimum seconds before redial',
            removeRequest: 'Remove from list request mode',
            customerDefault: 'Chose as Default Template',
            vmDetect: 'Enable automatic voicemail detection system',
            playPrivateMsg: 'Enable playing customized message based on the called number',
            blockedEntriesCount: 'Number of Blocked Entries',
            incomingPolicy: 'Incoming Calls Policy Setup',
            phone: 'Phone Number',
            moreinfo: 'General Info',
            blocked: 'Blocked Number?',
            uploader: 'Click to Chose Template Message'
        },
        campaigns: {
            name: "Campaigns"
        },
        activecampaigns: {
            name: "Active Campaigns"
        },
        CRM: {
            name: 'CRM',
            employees: {
                name: 'Employees',
            },
            customers: {
                name: 'Customers',
            },
            calls: {
                name: 'Calls',
            },
            tasks: {
                name: 'Tasks',
            },
            deals: {
                name: 'Deals',
            },
            documents: {
                name: 'Documents',
            },
            products: {
                name: 'Products',
            },
            projects: {
                name: 'Projects',
            },
                                
        },
        Campaigns: {
            name: 'Active Campaigns',
        },
        scheduled: {
            name: 'Scheduled Campaigns',
            schedID: 'Campaign ID',
            ip: 'IP address where campaign was set',
            createTime: 'Time the campaign was set',
            startTime: 'Time the campaign will start',
        },

        customers: {
            name: 'Customer |||| Customers',
            fields: {
                commands: 'Orders',
                groups: 'Segments',
                last_seen_gte: 'Visited Since',
                name: 'Name',
                total_spent: 'Total spent',
            },
            tabs: {
                identity: 'Identity',
                address: 'Address',
                orders: 'Orders',
                reviews: 'Reviews',
                stats: 'Stats',
            },
            page: {
                delete: 'Delete Customer',
            },
        },
        commands: {
            name: 'Order |||| Orders',
            fields: {
                basket: {
                    delivery: 'Delivery',
                    reference: 'Reference',
                    quantity: 'Quantity',
                    sum: 'Sum',
                    tax_rate: 'Tax Rate',
                    total: 'Total',
                    unit_price: 'Unit Price',
                },
                customer_id: 'Customer',
                date_gte: 'Passed Since',
                date_lte: 'Passed Before',
                total_gte: 'Min amount',
                status: 'Status',
                returned: 'Returned',
            },
        },
        products: {
            name: 'Poster |||| Posters',
            fields: {
                category_id: 'Category',
                height_gte: 'Min height',
                height_lte: 'Max height',
                height: 'Height',
                image: 'Image',
                price: 'Price',
                reference: 'Reference',
                stock_lte: 'Low Stock',
                stock: 'Stock',
                thumbnail: 'Thumbnail',
                width_gte: 'Min width',
                width_lte: 'Max width',
                width: 'Width',
            },
            tabs: {
                image: 'Image',
                details: 'Details',
                description: 'Description',
                reviews: 'Reviews',
            },
        },
        categories: {
            name: 'Category |||| Categories',
            fields: {
                products: 'Products',
            },
        },
        reviews: {
            name: 'Review |||| Reviews',
            fields: {
                customer_id: 'Customer',
                command_id: 'Order',
                product_id: 'Product',
                date_gte: 'Posted since',
                date_lte: 'Posted before',
                date: 'Date',
                comment: 'Comment',
                rating: 'Rating',
            },
            action: {
                accept: 'Accept',
                reject: 'Reject',
            },
            notification: {
                approved_success: 'Review approved',
                approved_error: 'Error: Review not approved',
                rejected_success: 'Review rejected',
                rejected_error: 'Error: Review not rejected',
            },
        }
    },
    ra: {
        action: {
            insertRow: 'Add Row',
            insertColumn: 'Add Column',
            add_filter: 'Add filter',
            add: 'Add',
            back: 'Go Back',
            bulk_actions: '1 item selected |||| %{smart_count} items selected',
            cancel: 'Cancel',
            clear_input_value: 'Clear value',
            clone: 'Clone',
            confirm: 'Confirm',
            create: 'Create',
            delete: 'Delete',
            edit: 'Edit',
            export: 'Export',
            list: 'List',
            refresh: 'Refresh',
            remove_filter: 'Remove this filter',
            remove: 'Remove',
            save: 'Save',
            search: 'Search',
            show: 'Show',
            sort: 'Sort',
            undo: 'Undo',
            upload: 'Upload',
            close: 'Close',
            ok: 'OK'
        },
        boolean: {
            true: 'Yes',
            false: 'No',
        },
        page: {
            create: 'Create %{name}',
            dashboard: 'Dashboard',
            edit: '%{name} #%{id}',
            error: 'Something went wrong',
            list: '%{name}',
            loading: 'Loading',
            not_found: 'Not Found',
            show: '%{name} #%{id}',
        },
        input: {
            file: {
                upload_several:
                    'Drop some files to upload, or click to select one.',
                upload_single: 'Drop a file to upload, or click to select it.',
            },
            image: {
                upload_several:
                    'Drop some pictures to upload, or click to select one.',
                upload_single:
                    'Drop a picture to upload, or click to select it.',
            },
            references: {
                all_missing: 'Unable to find references data.',
                many_missing:
                    'At least one of the associated references no longer appears to be available.',
                single_missing:
                    'Associated reference no longer appears to be available.',
            },
        },
        message: {
            about: 'About',
            are_you_sure: 'Are you sure?',
            bulk_delete_content:
                'Are you sure you want to delete this %{name}? |||| Are you sure you want to delete these %{smart_count} items?',
            bulk_delete_title:
                'Delete %{name} |||| Delete %{smart_count} %{name}',
            delete_content: 'Are you sure you want to delete this item?',
            delete_title: 'Delete %{name} #%{id}',
            details: 'Details',
            error:
                "A client error occurred and your request couldn't be completed.",
            invalid_form: 'The form is not valid. Please check for errors',
            loading: 'The page is loading, just a moment please',
            no: 'No',
            not_found:
                'Either you typed a wrong URL, or you followed a bad link.',
            yes: 'Yes',
        },
        navigation: {
            no_results: 'No results found',
            no_more_results:
                'The page number %{page} is out of boundaries. Try the previous page.',
            page_out_of_boundaries: 'Page number %{page} out of boundaries',
            page_out_from_end: 'Cannot go after last page',
            page_out_from_begin: 'Cannot go before page 1',
            page_range_info: '%{offsetBegin}-%{offsetEnd} of %{total}',
            page_rows_per_page: 'Rows per page:',
            next: 'Next',
            prev: 'Prev',
        },
        auth: {
            title: 'Login',
            user_menu: 'Profile',
            username: 'Username',
            password: 'Password',
            sign_in: 'Sign in',
            sign_in_error: 'Authentication failed, please retry',
            logout: '',
            ADMINpassword: 'Admin password',
            ADMINtitle: 'admin password for multi user',
        },
        notification: {
            updated: 'Element updated |||| %{smart_count} elements updated',
            created: 'Element created',
            deleted: 'Element deleted |||| %{smart_count} elements deleted',
            bad_item: 'Incorrect element',
            item_doesnt_exist: 'Element does not exist',
            http_error: 'Server communication error',
            data_provider_error:
                'dataProvider error. Check the console for details.',
            canceled: 'Action cancelled',
            logged_out: 'Your session has ended, please reconnect.',
        },
        validation: {
            required: 'Required',
            minLength: 'Must be %{min} characters at least',
            maxLength: 'Must be %{max} characters or less',
            minValue: 'Must be at least %{min}',
            maxValue: 'Must be %{max} or less',
            number: 'Must be a number',
            email: 'Must be a valid email',
            oneOf: 'Must be one of: %{options}',
            regex: 'Must match a specific format (regexp): %{pattern}',
        },
        tree: {
            root_targer: 'IVR Tree Root'
        }
    },
};
